import { css, Theme } from "@emotion/react";
import { OrderStatus } from "enums/orders";
import { handleColorStatusTransaction } from "helpers/showStatusText";
import { theme } from "styles/theme";

export const ItemTransactionStyle = {
  self: css`
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid ${theme.colors.gray[0]};
  `,

  header: css``,

  data: css`
    flex: 1;
    text-align: right;
  `,

  title: ({ colors }: Theme) => css`
    color: ${colors.black};
    font-size: 15px;
    margin-bottom: 8px;
    font-weight: 500;
  `,
  amount: ({ colors }: Theme) => css`
    color: ${colors.black};
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 6px;
  `,
  createdDate: ({ colors }: Theme) => css`
    font-size: 11px;
    color: ${colors.gray[200]};
    font-weight: 500;
  `,
  status: (status: OrderStatus) => css`
    color: ${handleColorStatusTransaction(status)};
    font-size: 11px;
    margin-bottom: 6px;
  `,
  depositType: ({ colors }: Theme) => css`
    color: ${colors.gray[200]};
    font-size: 11px;
    font-weight: 500;
    svg {
      vertical-align: middle;
    }
  `,
};
